import React, { useState } from "react";
import { Container, Row, Col, Card, ListGroup, Button, Badge } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import BookDemo from "./BookDemo";
import "./schoolproduct.scss";
import { useNavigate } from "react-router-dom";

function SchoolProdHome() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState("");

  const openDemo = (product) => {
   setSelectedProduct(product);
   setShow(true);
 };

  return (
    <section className="school-product-section py-5">
      <Container>

        {/* Section Header */}
        <div className="text-center mb-5">
          <Badge bg="primary" className="px-3 py-2 mb-3">
            Our Flagship Product
          </Badge>
          <h2 className="fw-bold display-6">
            Uiplus School ERP System
          </h2>
          <p className="text-muted">
            A complete cloud-based school management software designed to simplify 
            administration, enhance communication, and automate operations.
          </p>
        </div>

        <Row className="align-items-center">

          {/* LEFT IMAGE */}
          <Col md={5} className="mb-4 text-center">
            <img
              src="/images/uiplus-school-dashboard.png"
              alt="Uiplus School ERP Dashboard"
              className="img-fluid rounded shadow-lg"
            />
          </Col>

          {/* RIGHT CONTENT */}
          <Col md={7}>
            <Card className="border-0 shadow-lg p-2 product-modern-card">
              <Card.Body>

                <h5 className="fw-bold mb-3">
                  Smart School Management Made Simple
                </h5>

                <p className="text-muted" style={{textAlign:'justify'}}>
                  Uiplus eSchool ERP is an all-in-one digital platform that manages 
                  admissions, attendance, fees, exams, communication, and reporting 
                  efficiently from a single dashboard.
                </p>

                <Row className="mt-4">

                  <Col md={6}>
                    <h6 className="fw-bold mb-3">Admin Module</h6>
                    <ListGroup variant="flush">
                      <ListGroup.Item style={{padding:"5px"}}>
                        <CheckCircleFill className="text-primary me-2" />
                        Student & Staff Management
                      </ListGroup.Item>
                      <ListGroup.Item style={{padding:"5px"}}>
                        <CheckCircleFill className="text-primary me-2" />
                        Fees & Accounting System
                      </ListGroup.Item>
                      <ListGroup.Item style={{padding:"5px"}}>
                        <CheckCircleFill className="text-primary me-2" />
                        Reports & Analytics Dashboard
                      </ListGroup.Item>
                    </ListGroup>
                  </Col>

                  <Col md={6}>
                    <h6 className="fw-bold mb-3">Teacher Module</h6>
                    <ListGroup variant="flush">
                      <ListGroup.Item style={{padding:"5px"}}>
                        <CheckCircleFill className="text-primary me-2" />
                        Attendance & Examination
                      </ListGroup.Item>
                      <ListGroup.Item style={{padding:"5px"}}>
                        <CheckCircleFill className="text-primary me-2" />
                        Homework & Assignments
                      </ListGroup.Item>
                      <ListGroup.Item style={{padding:"5px"}}>
                        <CheckCircleFill className="text-primary me-2" />
                        Student Performance Tracking
                      </ListGroup.Item>
                    </ListGroup>
                  </Col>

                </Row>

                {/* Highlight Box */}
                <div className="mt-4 p-3 rounded bg-light border-start border-4 border-primary">
                  <strong>Why Schools Choose Uiplus ERP?</strong>
                  <p className="mb-0 mt-2 text-muted" style={{textAlign:'justify'}}>
                    Secure cloud infrastructure, user-friendly interface, customizable modules,
                    and reliable technical support for seamless academic operations.
                  </p>
                </div>

                {/* CTA Buttons */}
                <div className="mt-4 d-flex flex-wrap gap-3">
                  <Button variant="primary" onClick={() => openDemo("School ERP Application")}>
                    Book Demo
                  </Button>

                  <Button
                    variant="outline-primary"
                    onClick={() => navigate("/products/school-management")}
                  >
                    View Details
                  </Button>
                </div>

              </Card.Body>
            </Card>
          </Col>

        </Row>

      </Container>

      {/* <BookDemo show={showDemo} handleClose={() => setShowDemo(false)} /> */}
      <BookDemo
  show={show}
  handleClose={() => setShow(false)}
  productName={selectedProduct}
/>
    </section>
  );
}

export default SchoolProdHome;
